/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Error_ConflictInputs */

const cs_api_error_conflict = /** @type {(inputs: Api_Error_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Konflikt s aktuálním stavem. Obnovte stránku a zkuste to znovu.`)
};

const en_api_error_conflict = /** @type {(inputs: Api_Error_ConflictInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This conflicts with the current state. Refresh and try again.`)
};

/**
* | output |
* | --- |
* | "This conflicts with the current state. Refresh and try again." |
*
* @param {Api_Error_ConflictInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const api_error_conflict = /** @type {((inputs?: Api_Error_ConflictInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Error_ConflictInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_error_conflict(inputs)
	return cs_api_error_conflict(inputs)
});